<div class="container-fluid p-0">
  <div class="hpanel">
    <div class="panel-body b-r-6">
      <div class="card">
        <div class="card-header p-10-30">
          <h6> Plan details for your organization</h6>
        </div>
        <div class="card-body">
          <div class="product-list-custom custom-datatable">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Plan Name</th>
                    <th scope="col">Start Date</th>
                    <th scope="col">End Date</th>
                    <th scope="col">Subscription</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="ng-star-inserted">
                    <td>
                      <div class="text-primaryclr capitalize-first">
                        {{userPlanDetails?.membershipType}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{ effectiveFromDate | timezoneDate:'MM/dd/yyyy' }}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{ effectiveToDate | timezoneDate:'MM/dd/yyyy' }}
                      </div>
                    </td>

                    <td>
                      <div class="text-primaryclr capitalize-first">
                        {{userPlanDetails?.billingType?userPlanDetails?.billingType:'Month'}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr capitalize-first">
                        {{userPlanDetails?.status}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="product-list-custom custom-datatable">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Details</th>
                    <th scope="col">In Plan</th>
                    <th scope="col">Top Ups</th>
                    <th scope="col">Plan Final</th>
                    <th scope="col">Allocated</th>
                    <th scope="col">Promotional</th>
                    <th scope="col">Available</th>
                  </tr>
                </thead>
                <tbody>

                  <tr class="ng-star-inserted" *ngIf="role === 'SUPERADMIN' && checkUserPlan()">
                    <td> Active Users** </td>
                    <td>{{getTotal('ACTIVE_USERS')}}</td>
                    <td>{{getTopup('ACTIVE_USERS')}} </td>


                    <td>
                      <div class="text-primaryclr">
                        {{ getTotal('ACTIVE_USERS') + getTopup('ACTIVE_USERS') }}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        
                          {{ role === 'SUPERADMIN' && checkUserPlan()
                          ? getAllocated('ACTIVE_USERS')
                          : getTotal('ACTIVE_USERS') + getTopup('ACTIVE_USERS') }}
                        
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('ACTIVE_USERS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('ACTIVE_USERS')}}
                      </div>
                    </td>

                  </tr>


                  <tr class="ng-star-inserted" *ngIf="checkUserPlan()"> 
                    <td> Job/Candidate Spotlights**  </td>
                    <td>{{getTotal('JOBS_CANDIDATE_SPOTLIGHTS')}}</td>
                     <td>{{getTopup('JOBS_CANDIDATE_SPOTLIGHTS')}} </td>


                    <td>
                      <div class="text-primaryclr">
                        {{ getTotal('JOBS_CANDIDATE_SPOTLIGHTS') + getTopup('JOBS_CANDIDATE_SPOTLIGHTS') }}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        
                          {{ role === 'SUPERADMIN' && checkUserPlan()
                          ? getAllocated('JOBS_CANDIDATE_SPOTLIGHTS')
                          : getTotal('JOBS_CANDIDATE_SPOTLIGHTS') + getTopup('JOBS_CANDIDATE_SPOTLIGHTS') }}
                        
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('JOBS_CANDIDATE_SPOTLIGHTS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('JOBS_CANDIDATE_SPOTLIGHTS')}}
                      </div>
                    </td>

                  </tr>

                  <tr class="ng-star-inserted">
                    <td> Job/Candidate Postings ** </td>
                     <td>{{getTotal('JOBS_CANDIDATE_ACTIVE_CREATIONS')}}</td>
                     <td>{{getTopup('JOBS_CANDIDATE_ACTIVE_CREATIONS')}} </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getTotal('JOBS_CANDIDATE_ACTIVE_CREATIONS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAllocated('JOBS_CANDIDATE_ACTIVE_CREATIONS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('JOBS_CANDIDATE_ACTIVE_CREATIONS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('JOBS_CANDIDATE_ACTIVE_CREATIONS')}}
                      </div>
                    </td>
                  </tr> 

                  <tr class="ng-star-inserted">
                    <td>
                      Job/Candidate Slots**
                    </td>
                    <td>{{getTotal('JOB_CANDIDATE_POSTINGS')}}</td>
                    <td>
                      {{getTopup('JOB_CANDIDATE_POSTINGS')}}
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{ getTotal('JOB_CANDIDATE_POSTINGS') + getTopup('JOB_CANDIDATE_POSTINGS') }}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{ role === 'SUPERADMIN' && checkUserPlan()
                        ? getAllocated('JOB_CANDIDATE_POSTINGS')
                        : getTotal('JOB_CANDIDATE_POSTINGS') + getTopup('JOB_CANDIDATE_POSTINGS') }}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('JOB_CANDIDATE_POSTINGS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('JOB_CANDIDATE_POSTINGS')}}
                      </div>
                    </td>

                  </tr>

                  <tr class="ng-star-inserted">
                    <td>
                      Interactions*
                    </td>
                    <td>{{getTotal('ACTIVE_INTERACTIONS')}}</td>
                    <td>
                      {{getTopup('ACTIVE_INTERACTIONS')}}
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getTotal('ACTIVE_INTERACTIONS') + getTopup('ACTIVE_INTERACTIONS') }}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{ role === 'SUPERADMIN' && checkUserPlan()
                        ? getAllocated('ACTIVE_INTERACTIONS')
                        : getTotal('ACTIVE_INTERACTIONS') + getTopup('ACTIVE_INTERACTIONS') }}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('ACTIVE_INTERACTIONS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('ACTIVE_INTERACTIONS')}}
                      </div>
                    </td>

                  </tr>

                  <tr *ngIf="checkUserPlan()">
                    <td>
                      Workspaces**
                    </td>
                    <td>{{getTotal('TEAM_WORKSPACES')}}</td>
                    <td>
                      {{getTopup('TEAM_WORKSPACES')}}
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{ getTotal('TEAM_WORKSPACES') + getTopup('TEAM_WORKSPACES') }}
                      </div>
                    </td>
                    <td>
                      {{ role === 'SUPERADMIN' && checkUserPlan()
                      ? getAllocated('TEAM_WORKSPACES')
                      : getTotal('TEAM_WORKSPACES') + getTopup('TEAM_WORKSPACES') }}
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('TEAM_WORKSPACES')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('TEAM_WORKSPACES')}}
                      </div>
                    </td>
                  </tr>
                  
                  <tr *ngIf="role === 'SUPERADMIN' && checkUserPlan()" class="ng-star-inserted">
                    <td>

                      Members **
                    </td>
                    <td class="">{{getTotal('INCLUDED_CONVERSATIONS')}}</td>
                    <td>
                      {{getTopup('INCLUDED_CONVERSATIONS')}}
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        <!-- {{getTotal('INCLUDED_CONVERSATIONS') + getTopup('INCLUDED_CONVERSATIONS') }} -->
                        {{getTotal('INCLUDED_CONVERSATIONS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAllocated('INCLUDED_CONVERSATIONS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('INCLUDED_CONVERSATIONS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('INCLUDED_CONVERSATIONS')}}
                      </div>
                    </td>

                  </tr>

                  <tr *ngIf="role === 'SUPERADMIN' && checkUserPlan()">
                    <td>
                      Member Networks**
                    </td>
                    <td>{{getTotal('PERSONAL_NETWORKS')}}</td>
                    <td>
                      {{getTopup('PERSONAL_NETWORKS')}}
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        <!-- {{getTotal('PERSONAL_NETWORKS') + getTopup('PERSONAL_NETWORKS') }} -->
                        {{getTotal('PERSONAL_NETWORKS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAllocated('PERSONAL_NETWORKS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('PERSONAL_NETWORKS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('PERSONAL_NETWORKS')}}
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="role === 'SUPERADMIN' &&  checkUserPlan()">
                    <td>
                      Business**
                    </td>
                    <td>{{getTotal('B2B_CONTACTS')}}</td>
                    <td>
                      {{getTopup('B2B_CONTACTS')}}
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        <!-- {{getTotal('B2B_CONTACTS') + getTopup('B2B_CONTACTS') }} -->
                        {{getTotal('B2B_CONTACTS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAllocated('B2B_CONTACTS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('B2B_CONTACTS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('B2B_CONTACTS')}}
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="role === 'SUPERADMIN' &&  checkUserPlan()" class="ng-star-inserted">
                    <td>
                      Business Networks**
                    </td>
                    <td>{{getTotal('B2B_NETWORKS')}}</td>
                    <td>
                      {{getTopup('B2B_NETWORKS')}}
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        <!-- {{getTotal('B2B_NETWORKS') + getTopup('B2B_NETWORKS') }} -->
                        {{getTotal('B2B_NETWORKS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAllocated('B2B_NETWORKS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getpromotional('B2B_NETWORKS')}}
                      </div>
                    </td>
                    <td>
                      <div class="text-primaryclr">
                        {{getAvailable('B2B_NETWORKS')}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mr-tp-40 " style="color: red;">
            <div>
              *Credits reset on the 1st day of the new billing cycle.
            </div>
            <div>
              **Contact your customer success manager to increase your subscription quotas, or upgrade to a higher plan.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- <app-common-skeleton [NameOftheScreen]="'planDetails'"></app-common-skeleton> -->